import { createRoute, redirect, type AnyRoute } from "@tanstack/react-router";
import { ShieldCheck } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { RolesPage } from "./pages/RolesPage";

/** Search params on /system/roles — the active tab is shareable. */
export interface RolesSearch {
  tab?: "roles" | "catalog";
}

function validateRolesSearch(raw: Record<string, unknown>): RolesSearch {
  const out: RolesSearch = {};
  if (raw.tab === "roles" || raw.tab === "catalog") out.tab = raw.tab;
  return out;
}

export const rolesModule: FeatureModule = {
  key: "roles",
  nav: {
    label: "Roles",
    icon: ShieldCheck,
    to: "/system/roles",
    requires: "core.roles.read",
    order: 20,
    group: "System",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/system/roles",
      component: guarded("core.roles.read", RolesPage),
      validateSearch: validateRolesSearch,
    }),
    // Legacy paths from the old combined Admin section.
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/admin/roles",
      beforeLoad: () => {
        throw redirect({ to: "/system/roles" });
      },
    }),
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/admin/permissions",
      beforeLoad: () => {
        throw redirect({ to: "/system/roles", search: { tab: "catalog" } });
      },
    }),
  ] as unknown as AnyRoute[],
};
